import React from "react";
import MenuTool from "../../components/Toolnav/MenuTool";
import { CiSearch } from "react-icons/ci";

export default function AllNotifications() {
  return (
    <div>
      <MenuTool
        menus={[{ id: 1, name: "All Notifications", to: "/notifications" }]}
        actions={<></>}
      />
      <div className="m-2">
        <div className="p-2 flex flex-col items-center justify-center border bg-white h-48">
          <div className="">
            <CiSearch />
          </div>
          <div className="flex justify-between items-center">
            No Notifications
          </div>
          <div className="text-gray-500 text-xs">
            No notifications, please try again latter
          </div>
        </div>
      </div>
    </div>
  );
}
